import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from "lodash";

@Pipe({
    name: 'toFixed'
})
export class ToFixedPipe implements PipeTransform {
    transform(value: number, precision: number = 2): string | number {
        if (!isNil(value) && !isNaN(value)) {
            if (typeof value==='string') value = +value;
            return value.toFixed(precision);
        }
        return value;
    }
}
